import React from 'react';
import {TextArea} from '@blueprintjs/core';

import {StyledFormGroup, RoundedInputWrap} from './shared';


const TextAreaField = ({label, value, disabled, error, rows = 10, onChange}) => {
    const intent = error ? 'danger' : 'none';
    return (
        <StyledFormGroup label={label} helperText={error?.message} intent={intent}>
            <RoundedInputWrap>
                <TextArea
                    fill={true}
                    rows={rows}
                    value={value ?? ''}
                    disabled={disabled}
                    intent={intent}
                    onChange={(e) => onChange(e.target.value)}
                    style={{fontFamily: 'monospace', resize: 'vertical'}}
                />
            </RoundedInputWrap>
        </StyledFormGroup>
    );
};

export {TextAreaField};
